import {
  GET_ALLCATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,
  GET_CATEGORY_BY_ID_SUCCESS,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
};

const Category = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALLCATEGORIES:
      return {
        ...state,
        loading: true,
      };
    case GET_CATEGORIES_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_CATEGORY_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_CATEGORIES_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default Category;
